import styled from 'styled-components';

// ============ PEOPLE PANEL STYLES ============

export const PeoplePanelContainer = styled.div<{ $offsetTop?: number }>`
  position: fixed;
  right: ${({ theme }) => theme.spacing[6]};
  top: ${({ $offsetTop }) => `${$offsetTop ?? 120}px`};
  background: white;
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  width: 360px;
  max-height: ${({ $offsetTop, theme }) =>
    `clamp(320px, 70vh, calc(100vh - (${ $offsetTop ?? 120 }px + ${theme.spacing[8]})))`};
  overflow-y: auto;
  z-index: 99;

  @media (max-width: 1440px) {
    display: none;
  }
`;

export const PanelHeader = styled.div`
  padding: ${({ theme }) => `${theme.spacing[4]} ${theme.spacing[5]}`};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};
  background: #f9fafb;
  border-radius: ${({ theme }) => `${theme.borderRadius.xl} ${theme.borderRadius.xl} 0 0`};
`;

export const PanelTitle = styled.h3`
  margin: 0 0 ${({ theme }) => theme.spacing[1]} 0;
  font-size: ${({ theme }) => theme.typography.fontSize.lg};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.gray900};
`;

export const PanelSubtitle = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  color: ${({ theme }) => theme.colors.gray500};
`;

export const PanelContent = styled.div`
  padding: ${({ theme }) => theme.spacing[4]};
`;

export const SectionGroup = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing[5]};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  margin-bottom: ${({ theme }) => theme.spacing[3]};
  padding-bottom: ${({ theme }) => theme.spacing[2]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};
`;

export const SectionIcon = styled.span`
  font-size: 18px;
`;

export const SectionTitle = styled.h4`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.gray900};
  flex: 1;
`;

export const SectionBadge = styled.span`
  background: ${({ theme }) => theme.colors.gray100};
  color: ${({ theme }) => theme.colors.gray600};
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  padding: ${({ theme }) => `${theme.spacing[1]} ${theme.spacing[2]}`};
  border-radius: ${({ theme }) => theme.borderRadius.full};
`;

export const PersonCard = styled.div`
  padding: ${({ theme }) => theme.spacing[3]};
  background: #f9fafb;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  margin-bottom: ${({ theme }) => theme.spacing[2]};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PersonName = styled.div`
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.gray900};
  margin-bottom: ${({ theme }) => theme.spacing[1]};
`;

export const PersonRole = styled.div`
  color: ${({ theme }) => theme.colors.gray600};
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  margin-bottom: ${({ theme }) => theme.spacing[1]};
`;

export const PersonMetaList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[1]};
`;

export const PersonMeta = styled.div`
  color: ${({ theme }) => theme.colors.gray600};
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing[1]};
`;

export const PersonMetaLabel = styled.span`
  color: ${({ theme }) => theme.colors.gray500};
  min-width: 50px;
`;

export const PersonMetaValue = styled.span`
  color: ${({ theme }) => theme.colors.gray700};
  flex: 1;
`;

export const AuthorityGroup = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing[2]};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const AuthorityLabel = styled.div`
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.gray900};
  margin-bottom: ${({ theme }) => theme.spacing[1]};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
`;

export const AuthorityItems = styled.div`
  margin-left: ${({ theme }) => theme.spacing[3]};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[1]};
`;

export const AuthorityItem = styled.div`
  color: ${({ theme }) => theme.colors.gray600};
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing[2]};
`;

export const BlockingStakeholder = styled.div`
  padding: ${({ theme }) => theme.spacing[3]};
  background: #fef2f2;
  border-left: 3px solid #ef4444;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  margin-bottom: ${({ theme }) => theme.spacing[2]};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const BlockingName = styled.div`
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: #991b1b;
  margin-bottom: ${({ theme }) => theme.spacing[1]};
`;

export const BlockingMeta = styled.div`
  color: #7f1d1d;
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[1]};
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spacing[4]};
  color: ${({ theme }) => theme.colors.gray500};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
`;
